// 读取本地视频时长（秒）。通过 video 元素的元数据获取，无需把文件传到服务端
function readVideoDuration(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const video = document.createElement("video");
    video.preload = "metadata";

    const cleanup = () => {
      video.onloadedmetadata = null;
      video.onerror = null;
      video.removeAttribute("src");
      URL.revokeObjectURL(url);
    };

    video.onloadedmetadata = () => {
      const duration = video.duration;
      cleanup();
      resolve(duration);
    };
    video.onerror = () => {
      cleanup();
      reject(new Error("无法读取视频时长"));
    };
    video.src = url;
  });
}

// 秒数格式化为 “X分钟” 或 “X分Y秒”
function formatVideoTime(seconds) {
  const total = Math.floor(seconds);
  if (total % 60 === 0) {
    return `${total / 60}分钟`;
  }
  return `${Math.floor(total / 60)}分${total % 60}秒`;
}

// 校验视频时长，合法时返回 null，否则返回错误提示文案。
// range 为 [最小时长, 最大时长]，单位秒，由上传项通过 videoDurationRange 声明
function validateVideoDuration(file, range) {
  const minSeconds = range[0];
  const maxSeconds = range[1];
  return readVideoDuration(file)
    .then(duration => {
      // 浏览器解析不出时长（部分编码的视频会返回 Infinity/NaN），放行上传，由后端兜底拦截
      if (!isFinite(duration) || duration <= 0) {
        return null;
      }
      // 与后端一致：时长向下取整到秒
      const seconds = Math.floor(duration);
      if (seconds < minSeconds || seconds > maxSeconds) {
        return `视频时长需在${formatVideoTime(minSeconds)}-${formatVideoTime(maxSeconds)}之间，当前视频时长 ${formatVideoTime(seconds)}`;
      }
      return null;
    })
    // 读取失败（编码不支持等）同样放行，由后端兜底拦截
    .catch(() => null);
}

export function regFile(file, fileList, fileindex, item) {
	console.log(file.type,item.accept.toLowerCase());
  if (item.accept.toLowerCase() == '.mp4' && file.type == 'video/mp4') {
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error("请上传大小在 1000M 以内的文件");
      return false;
    } 
    // else if (file.size > 1024 * 1024 * 5000) {
    //   this.$message.error('请上传大小在 5G 以内的文件');
    //   return false;
    // }
  } else if (file.type == 'application/pdf' && item.accept.toLowerCase() == '.pdf') {
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error('请上传大小在 1000M 以内的文件');
      return false;
    }
  }else if (file.type == 'application/msword' && item.accept.toLowerCase() == '.doc,.docx') {
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error('请上传大小在 1000M 以内的文件');
      return false;
    }
  } else if ((file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type == 'application/pdf' || file.type == 'application/vnd.ms-excel' || file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') && item.accept.toLowerCase() == '.pdf,.docx,.xls,.xlsx') {
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error('请上传大小在 1000M 以内的文件');
      return false;
    }
  } else if (file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && item.accept.toLowerCase() == '.doc,.docx') {
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error('请上传大小在 1000M 以内的文件');
      return false;
    }
  }else if ((file.type=='application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type == 'application/pdf') && item.accept.toLowerCase() == '.pdf,.docx'){
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error('请上传大小在 1000M 以内的文件');
      return false;
    }
  }else if ((file.type == 'application/pdf' || file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png') && item.accept.toLowerCase() == '.pdf,.jpg,.jpeg,.png'){
    if (file.size > 1024 * 1024 * 1000) {
      this.$message.error('请上传大小在 1000M 以内的文件');
      return false;
    }
  }else{
    this.$message.warn('请上传正确格式的文件');
    return false;
  }
  // 参赛作品推荐表（accept 同时含 pdf 与图片）：允许 1 个 pdf + 1 张图片
  if (item.accept.toLowerCase() == '.pdf,.jpg,.jpeg,.png') {
    let isImage = file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png';
    let sameTypeExist = item.fileList.some((f) => {
      let name = f.name1 || f.name || '';
      return /\.(jpg|jpeg|png)$/i.test(name) == isImage;
    });
    if (sameTypeExist) {
      this.$message.warning(isImage ? '图片只能上传一张！' : 'pdf只能上传一个！');
      return false;
    }
    this.handleUpload(fileindex, file);
    return;
  }
  // let nums = item.fileList.filter((item)=>{
  //   return item.fileType == '5' || item.fileType == '8' || item.fileType == '13'  || item.fileType == '19'
  // })
  let nums = item.fileList.filter((item)=>{
      return item.fileType == '1' 
  })
  let nums2 = item.fileList.filter((item)=>{
    return item.fileType == '2' 
  })
  let nums3 = item.fileList.filter((item)=>{
    return item.fileType == '3' 
  })
   let nums4 = item.fileList.filter((item)=>{
    return item.fileType == '4' 
  })
   let nums5= item.fileList.filter((item)=>{
    return item.fileType == '5' 
  })
   let nums6= item.fileList.filter((item)=>{
    return item.fileType == '6'
  })
   let nums7= item.fileList.filter((item)=>{
    return item.fileType == '7'
  })
   let nums8= item.fileList.filter((item)=>{
    return item.fileType == '8'
  })
  if(nums.length > 0){
    this.$message.warning('视频只能上传一个！');
    return false;
  }
  if(nums2.length > 0 || nums3.length > 0 || nums4.length > 0 || nums5.length > 0 || nums6.length > 0 || nums7.length > 0 || nums8.length > 0){
    this.$message.warning('文件只能上传一个！');
    return false;
  }
  // 视频若在 item 上声明了 videoDurationRange（[最小,最大]，单位分钟），
  // 需先读取时长校验，异步通过后再真正开始上传
  const durationRange = item.videoDurationRange;
  if (item.accept.toLowerCase() == '.mp4' && Array.isArray(durationRange) && durationRange.length == 2) {
    // 读取时长期间先占位 loading，避免重复点击触发多次上传
    this.loadList[fileindex].loading = true;
    validateVideoDuration(file, durationRange).then(msg => {
      if (msg) {
        this.loadList[fileindex].loading = false;
        this.$message.error(msg);
        return;
      }
      this.handleUpload(fileindex, file);
    });
    return;
  }
  this.handleUpload(fileindex, file);
}